// import React from 'react';
// import ReactDOM from 'react-dom';
// import { createStore, applyMiddleware } from 'redux';
// import { Provider } from 'react-redux';
// import thunk from 'redux-thunk';
// import { composeWithDevTools } from 'redux-devtools-extension';
// import rootReducer from './reducers';
// import { BrowserRouter } from 'react-router-dom';
// import App from './components/App'
// import "./index.css";

// const startApp = () => {
//     const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(thunk)));
//        if ('serviceWorker' in navigator) {
//       navigator.serviceWorker.register('/firebase-messaging-sw.js')
//         .then(function(registration) {
//           console.log('Service Worker registered with scope:', registration.scope);
//         })
//         .catch(function(err) {
//           console.log('Service Worker registration failed:', err);
//         });
//     }
    
    
//     ReactDOM.render(
//         <Provider store={store}><BrowserRouter><App/></BrowserRouter></Provider>,
//         document.getElementById('root')
//     );
// }

// if(window.cordova) {
//   document.addEventListener('deviceready', startApp, false)
// } 
// else {
//   startApp()
// }

import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import rootReducer from './reducers';
import { BrowserRouter } from 'react-router-dom';
import App from './components/App'
import "./design-tokens.css";
import "./index.css";
import "./ui.css";
import "./responsive.css";

const startApp = () => {
    const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(thunk)));
    ReactDOM.render(
        <Provider store={store}><BrowserRouter><App/></BrowserRouter></Provider>,
        document.getElementById('root')
    );
}

if(window.cordova) {
  document.addEventListener('deviceready', startApp, false)
} 
else {
  startApp()
}